module.exports = __webpack_public_path__ + "media/images/fv2-33a1871ba10b76b19c8e978fda683117.jpg";